import React from 'react';
import { ClockIcon } from 'lucide-react';
const quarters = [{
  q: 'Q1',
  name: 'Warm-Up Game',
  mins: '15 min',
  body: 'Sharks & Minnows with flags. Everyone moving in 60 seconds — no laps, no lines.',
  color: 'bg-q1',
  bar: 'border-l-q1'
}, {
  q: 'Q2',
  name: 'Skill Stations',
  mins: '15 min',
  body: 'Three stations, rotate on the whistle: catching, flag-pulling, ball-carrying.',
  color: 'bg-q2',
  bar: 'border-l-q2'
}, {
  q: 'Q3',
  name: 'Team Install',
  mins: '15 min',
  body: 'Install one play from The Starter Five. Walk it, then run it at half speed.',
  color: 'bg-q3',
  bar: 'border-l-q3'
}, {
  q: 'Q4',
  name: 'Live Game',
  mins: '15 min',
  body: 'Scrimmage with one focus rule: every player touches the ball once a drive.',
  color: 'bg-q4',
  bar: 'border-l-q4'
}];
export function PracticeCard() {
  return <section aria-labelledby="card-heading" className="w-full bg-white text-ink" data-id="element-177" data-mp="kjbkivd1h1yv">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-178" data-mp="sf3evfgbrgvw">
        <div className="text-center" data-id="element-179" data-mp="sdilht5qy3zm">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-180" data-mp="of301tpbd3ob">
            See what&apos;s on the card
          </p>
          <h2 id="card-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-181" data-mp="124wtkpbrkc4d">
            One practice. One card. Four quarters.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-182" data-mp="9iu34yswb2f2">
            This is one of the 142. Print it, clip it to your board, and coach
            straight down the page. No file to open on the field.
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-xl overflow-hidden rounded-2xl border border-ice-dark bg-white shadow-card" data-id="element-183" data-mp="ef2es27vwdhh">
          <div className="flex items-center justify-between bg-navy px-5 py-4" data-id="element-184" data-mp="1ussiv8z071r4">
            <div data-id="element-185" data-mp="1pu7klf3bas5b">
              <p className="font-display text-[11px] uppercase tracking-widest text-gold" data-id="element-186" data-mp="1pur0kq9ej6gp">
                Practice Card · Vol. 1 Build the Routine
              </p>
              <p className="font-display text-2xl leading-none text-white" data-id="element-187" data-mp="21wse9gfpt3q2">
                R-12 · First Full Scrimmage
              </p>
            </div>
            <div className="text-right" data-id="element-188" data-mp="26uk7cds3ivvu">
              <p className="flex items-center gap-1 font-display text-2xl leading-none text-white tabular-nums" data-id="element-189" data-mp="2bvzqg0apqsbl">
                <ClockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-190" data-mp="1e90opb55yu6u" />
                60
              </p>
              <p className="text-[9px] font-bold uppercase tracking-widest text-white/60" data-id="element-191" data-mp="1j7lqhf02dlxe">
                5v5 · Level 1
              </p>
            </div>
          </div>

          <ul data-id="element-192" data-mp="1sx58yjjv7drq">
            {quarters.map(qr => <li key={qr.q} className={`flex gap-3 border-b border-l-4 border-ice-dark ${qr.bar} px-5 py-3.5`} data-id="element-193" data-mp="1syyflyuh9xzq">
                <span className={`flex h-10 w-10 flex-none items-center justify-center rounded-lg font-display text-base font-bold text-white ${qr.color}`} data-id="element-194" data-mp="10f9r914pj0rh">
                  {qr.q}
                </span>
                <div className="min-w-0" data-id="element-195" data-mp="nw4d36foj6lt">
                  <p className="flex items-center gap-2 text-sm font-bold text-ink" data-id="element-196" data-mp="iy2t8jafj39a">
                    {qr.name}
                    <span className="text-[11px] font-medium text-ink-muted" data-id="element-197" data-mp="dyzm8taw2myo">
                      {qr.mins}
                    </span>
                  </p>
                  <p className="mt-0.5 text-[13px] text-ink-soft" data-id="element-198" data-mp="57r14kduh4i5">{qr.body}</p>
                </div>
              </li>)}
          </ul>

          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 bg-turf-soft px-5 py-3" data-id="element-199" data-mp="8w7enec9vj9">
            <span className="font-display text-[11px] font-bold uppercase tracking-widest text-turf" data-id="element-200" data-mp="3rg09r4zjgtlc">
              Coach&apos;s Eye
            </span>
            <span className="text-[13px] text-ink-soft" data-id="element-201" data-mp="3ie97yb84d6wr">
              If Q4 falls apart, shrink the field before you add a rule.
            </span>
          </div>
          <div className="flex items-center gap-2 px-5 py-3 text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-202" data-mp="b013s5scqpa6">
            Bring: 8 cones · 1 ball · flags for all
          </div>
        </div>
      </div>
    </section>;
}